import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICompanyVoteProposalNameListState } from '../states/company-vote-proposal-name-list.state';

export const selectCompanyVoteProposalNameListState = createFeatureSelector<ICompanyVoteProposalNameListState>('companyVoteProposalNameList');

export const selectCompanyVoteProposalNameSearchFilter = createSelector(
  selectCompanyVoteProposalNameListState,
  (state: ICompanyVoteProposalNameListState) => state.searchFilter
);

export const selectCompanyVoteProposalNamePagination = createSelector(
  selectCompanyVoteProposalNameListState,
  (state: ICompanyVoteProposalNameListState) => ({
    currentPage: state.currentPage,
    pageSize: state.pageSize
  })
);

export const selectCompanyVoteProposalNameSort = createSelector(
  selectCompanyVoteProposalNameListState,
  (state: ICompanyVoteProposalNameListState) => ({
    sortBy: state.sortBy,
    ascending: state.ascending
  })
);

export const selectCompanyVoteProposalNameListFullState = createSelector(
  selectCompanyVoteProposalNameListState,
  (state: ICompanyVoteProposalNameListState) => state
);
